module.exports = __webpack_public_path__ + "img/459.8e05af4e.jpg";